// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__RnxT3","dragIcon":"SortableItem_dragIcon__1aK43","disabled":"SortableItem_disabled__2Hqzw"};